import { left, right } from 'fp-ts/Either';

import { httpClientFunction } from 'domain/types';
import CreateLinkClient from 'use-case/link/create/createLinkClient';
import CreateLinkCriteria from 'use-case/link/create/createLinkCriteria';
import Link from 'domain/entity/link';

const createLinkApiClient = (httpClient: httpClientFunction, baseUrl: string): CreateLinkClient => (criteria: CreateLinkCriteria) =>
    httpClient(`${baseUrl}/dashboards/dashboards/${criteria.dashboardId}/links`, {
        method: 'POST',
        body: JSON.stringify({ location_id: criteria.locationId.toString() }),
        headers: { 'Content-Type': 'application/json' },
    })
        .then((response) =>
            response.ok
                ? response
                      .json()
                      .then(asLink)
                      .then(right)
                      .catch(() => left({ error: new Error(), status: 500 }))
                : left({ error: new Error(), status: response.status })
        )
        .catch(() => left({ error: new Error(), status: 503 }));

const asLink = (linkJson: LinkJson) => new Link(linkJson.id, linkJson.linked_url, linkJson.active);

export type LinkJson = {
    id: string;
    ['linked_url']: string;
    active: boolean;
};

export default createLinkApiClient;
